import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { Routes, rootRouteRef } from './routes';

export const confidenceUserSettingsPlugin = createPlugin({
  id: 'confidence-user-settings',
  routes: {
    ...Routes,
  },
});

export const ConfidenceUserSettingsPage = confidenceUserSettingsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceUserSettingsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-user-settings", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
